import { Route } from '@angular/router';
import { DemoRoutingMatcher } from './demo-routing.matcher';

export const DEMO_ROUTES: Route[] = [
    {
        path: 'finder-api',
        loadComponent: () => import('./finder-api/finder-api.component').then((comp) => comp.FinderApiComponent),
    },
    {
        path: 'device-detection',
        loadComponent: () => import('./device-detection/device-detection.component').then((comp) => comp.DeviceDetectionComponent),
    },
    {
        path: '',
        redirectTo: 'web-components',
        pathMatch: 'full',
    },
    {
        /**
         * We resolve the route in the child routes file because there's an issue
         * where the route.paramMap isn't ready if we place it in app.routes.
         * This seems to be a special case and since it doesn't reach the guest
         * I'll just leave it alone
         */
        matcher: DemoRoutingMatcher,
        loadComponent: () => import('./web-components/web-components.component').then((comp) => comp.WebComponentsComponent),
    },
];
